export default "__VITE_ASSET__B5QCvFT0__"